import * as THREE from 'three';
import { SLINGSHOT_ORIGIN } from './slingshot';

// The solid shell is about 6.8 units across on the 14.1-unit board.
export const CORE_BOARD_SCALE = 3.6;
export const CORE_BOARD_POSITION = new THREE.Vector3(0, 3.2, -11.6);
export const CORE_BOARD_FACING_TARGET = new THREE.Vector3(
  SLINGSHOT_ORIGIN.x,
  SLINGSHOT_ORIGIN.y,
  SLINGSHOT_ORIGIN.z
);
export const CORE_BOARD_STRIKE_TARGET =
  CORE_BOARD_POSITION.clone().addScaledVector(
    CORE_BOARD_FACING_TARGET.clone().sub(CORE_BOARD_POSITION).normalize(),
    3.1
  );
export const CORE_BOARD_FRAME_RADIUS = 4.6;

// Fit the round silhouette rather than the empty corners of its bounding cube.
// The 3% margin encloses the sphere between the sampled directions as well.
export const CORE_BOARD_FRAME_POINTS = Array.from(
  { length: 9 },
  (_, latitude) =>
    Array.from({ length: 16 }, (_, longitude) =>
      new THREE.Vector3()
        .setFromSphericalCoords(
          CORE_BOARD_FRAME_RADIUS * 1.03,
          (latitude * Math.PI) / 8,
          (longitude * Math.PI) / 8
        )
        .add(CORE_BOARD_POSITION)
    )
).flat();
